import {
  customerCategories,
  CustomerDoc,
  customerDocSerializer,
  CustomerPricingRules,
  customerStatuses,
  relationTypes,
} from "@megaron/crm-contracts";
import { HttpAction } from "@megaron/http-service";
import { customerSortFields } from "@megaron/megarax-uri";
import { Serializers } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

export { customerDocSerializer };
export type { CustomerDoc, CustomerPricingRules };

export { customerSortFields };
export type { CustomerSortField } from "@megaron/megarax-uri";

export const customerActions = {
  searchCustomers: HttpAction({
    path: "/customers",
    qsSerializer: Serializers.object({
      searchText: Serializers.string,
      sort: Serializers.sortFilter(customerSortFields).asJsonString(),
      isPro: Serializers.boolean.asJsonString(),
      isAffiliate: Serializers.boolean.asJsonString(),
      tags: Serializers.string.array().asJsonString(),
      regions: Serializers.string.array().asJsonString(),
      isArchived: Serializers.boolean.asJsonString(),
      isUnassigned: Serializers.boolean.asJsonString(),
      isActive: Serializers.boolean.asJsonString(),
      status: Serializers.stringOneOf(...customerStatuses)
        .array()
        .asJsonString(),
      hasPricingRules: Serializers.booleanFieldFilter,
      isOnTradeRoute: Serializers.booleanFieldFilter,
      lastPurchaseTimeBefore: Serializers.datetime,
      lastPurchaseTimeAfter: Serializers.datetime,
      lastInteractionTimeBefore: Serializers.datetime,
      lastInteractionTimeAfter: Serializers.datetime,
      lastVisitTimeBefore: Serializers.datetime,
      lastVisitTimeAfter: Serializers.datetime,
      limit: Serializers.integer,
      offset: Serializers.integer,
      loyaltyJoinedAtStartDate: Serializers.datetime,
      loyaltyJoinedAtEndDate: Serializers.datetime,
      hasGooglePlaceId: Serializers.boolean.asJsonString(),
      categories: Serializers.stringOneOf(...customerCategories)
        .array()
        .asJsonString(),
      scannedProducts: Serializers.string.array().asJsonString(),
      relation: Serializers.object({
        relationType: Serializers.stringOneOf(...relationTypes),
        parents: Serializers.string.array(),
      }).asJsonString(),
      nearCoordinates: Serializers.object({
        latitude: Serializers.float,
        longitude: Serializers.float,
        rangeKm: Serializers.float,
      }).asJsonString(),
    }).partial(),
    valueSerializer: Serializers.paginatedList(customerDocSerializer),
    requiresAuth: true,
  }),

  customerWithGooglePlaceIdExistsQuery: HttpAction({
    path: "/customers/sameGooglePlaceId",
    qsSerializer: Serializers.object({
      googlePlaceId: Serializers.string,
    }),
    requiresAuth: true,
    valueSerializer: Serializers.object({
      uuid: uuidSerializer,
      name: Serializers.string,
    }).array(),
  }),
};
